import { useOutletContext } from 'react-router-dom'
import { Alteracao } from 'service/api'

export function useAlteracoesOutletContext() {
    return useOutletContext<{ data: Alteracao[] }>()
}
